import React, { Component } from 'react';
import {reduxForm, Field} from 'redux-form';
import {FormattedHTMLMessage} from 'react-intl';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js';
import generateValidator from './Validations/generateValidator';
import Section from './Section.js';
import CustomSpinner from './CustomSpinner';
import RenderField from './RenderField';
import CustomAlert from '../components/CustomAlert.js';

class AmountForm extends Component {

    constructor(props) {
        super(props);
    }

    render() {

        const { handleSubmit, submitting, error } = this.props;

        return (
            <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                        <FormattedHTMLMessage id="app.step_amount" description="Amount Form"/>
                    </div>
                    <div className="pd-content-right short-content col-sm-12 col-md-7 col-lg-7">
                        <form onSubmit={handleSubmit(this.props.saveProductionAmounts)} className="pvc-form">
                            {this.props.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
                            {error && <CustomAlert bsStyle="danger" message={error}/>}
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <h4>Anticipo cosecha a productores</h4>
                                    <div className="form-group">
                                        <Field className="form-control" name="producers_harvest_amount" autoComplete="off" component={RenderField} type="currency" label="Ingresá el Monto" placeholder='Ingresá el Monto'/>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <h4>Anticipo cosecha propio</h4>
                                    <div className="form-group">
                                        <Field className="form-control" name="harvest_amount" autoComplete="off" component={RenderField} type="currency" label="Ingresá el Monto" placeholder='Ingresá el Monto'/>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <h4>Gastos de elaboración</h4>
                                    <div className="form-group">
                                        <Field className="form-control" name="production_expenses" autoComplete="off" component={RenderField} type="currency" label="Ingresá el Monto" placeholder='Ingresá el Monto'/>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Continuar</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </Section>
        );
    }
}

AmountForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

let validate = generateValidator([
    {name: 'producers_harvest_amount', required: true, 'range':{'max': 150000000}},
    {name: 'harvest_amount', required: true, 'range':{'max': 150000000}},
    {name: 'production_expenses', required: true, 'range':{'max': 150000000}}
]);

AmountForm = TopScrolleable(AmountForm);

AmountForm = reduxForm({
    form: 'AmountForm', // a unique name for this form
    validate
})(AmountForm);

AmountForm = withAuthControl(AmountForm);

export default AmountForm;


/** WEBPACK FOOTER **
 ** ./src/components/ProductionAmountsForm.js
 **/